<template><div><h1>快速入门</h1>
<div class="warning">
<p>vux@2.x 推荐<code>webpack+vue-loader</code>方式的开发，如果要使用<code>umd</code>文件，请参照<router-link to="/zh-CN/install/umd.html">文档</router-link>。不建议使用引入<code>script</code>的方式进行开发，因为它会带来一系列的开发、维护、效率、部署问题。<br><br>
<strong>Life is short, use webpack.</strong></p>
</div>
<h2>vux2 模板</h2>
<div class="tip">
<p><a href="http://github.com/airyland/vux2">vux2</a> 模板 fork 自 <a href="https://github.com/vuejs-templates/webpack">webpack</a> 模板，基本和官方同步。</p>
</div>
<p>默认为 webpack2 模板</p>
<pre class="hljs"><code>npm install vue-cli -g <span class="hljs-comment"># 如果还没安装</span>
vue init airyland/vux2 projectPath

<span class="hljs-built_in">cd</span> projectPath
npm install --registry=https://registry.npm.taobao.org <span class="hljs-comment"># 或者 cnpm install 或者  yarn</span>
npm run dev <span class="hljs-comment">#  或者  yarn dev</span>
</code></pre>
<h2>使用淘宝 npm 镜像</h2>
<h3>cnpm</h3>
<p>你可以直接使用 <code>cnpm</code> 来加速模块下载。</p>
<h3>yarn</h3>
<p>或者如果你已经用上了 <code>yarn</code>，建议配置淘宝源：</p>
<pre class="hljs"><code>yarn config <span class="hljs-built_in">set</span> registry https://registry.npm.taobao.org
yarn
</code></pre>
</div></template><script>
export default {
  head: {"title":"VUX 入门教程 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// biolerplate-295.vue?508c2a81